import React from 'react';

const ContentWrapper = ({ children }) => (
  <div className="container-fluid page-body-wrapper">
    <div className="main-panel">
      <div className="content-wrapper">{children}</div>
    </div>
  </div>
);

export default ContentWrapper;
